import { defineComponent as _defineComponent } from 'vue'
import type { EditorialListTitleFragment } from '@/features/editorial/graphql/fragments/EditorialListTitle.fragment';

import BasicButton from '@/ui-components/BasicButton.vue';
import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import TitleScoreList from '@/components/TitleScoreList.vue';
import TextCollapse from '@/components/TextCollapse.vue';

import { useEditorialTracking } from '@/features/editorial/tracking';

import { ObjectType } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';
import { useWindowSize } from '@vueuse/core';
import { faThumbsUp, faThumbsDown, faBookmark } from '@fortawesome/free-solid-svg-icons';

import { isInWatchList, isInLikeList, isInDislikeList, useListActions } from '@/helpers/composables/useListActions';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListArticleItem',
  props: {
    title: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
	title: EditorialListTitleFragment;
	index: number;
};



const { trackEditorial } = useEditorialTracking();
const { width } = useWindowSize();

const shortDescriptionClamp = computed(() => (width.value > 768 ? 7 : 13));

const { t } = useI18n();

const { setInWatchlist, setInLikelist, setInDislikelist } = useListActions();
const isTitleInWatchList = computed(() => isInWatchList(props.title));
const isTitleInLikeList = computed(() => isInLikeList(props.title));
const isTitleInDislikeList = computed(() => isInDislikeList(props.title));

const titleDetails = computed(() => ({
	title: props.title.content.title,
	objectId: props.title.objectId,
	objectType: props.title.objectType,
}));

const watchlistActionLabel = computed(() => {
	if (props.title.objectType === ObjectType.Movie) {
		return t('WEBAPP_WATCHLIST');
	}

	return isTitleInWatchList.value ? t('WEBAPP_TRACKING') : t('WEBAPP_WATCHLIST_TV_SHOW_START_TRACKING');
});

/* TRACKING */
function trackClicksOnTitle() {
	trackEditorial('clicksOnTitle', { contexts: [SnowplowTitleContextGraphql.fromTitle(props.title)] });
}

function trackClickOnReadMore(target: EventTarget | null) {
	if (!target) return;

	trackEditorial('clickOnReadMore', {
		spec: { action: (target as HTMLInputElement).checked ? 'expanded' : 'collapsed' },
	});
}

return { __sfc: true,props, trackEditorial, width, shortDescriptionClamp, t, setInWatchlist, setInLikelist, setInDislikelist, isTitleInWatchList, isTitleInLikeList, isTitleInDislikeList, titleDetails, watchlistActionLabel, trackClicksOnTitle, trackClickOnReadMore, BasicButton, GridBuyBox, PictureComp, TitleScoreList, TextCollapse, faThumbsUp, faThumbsDown, faBookmark }
}

})